import { Outlet } from "react-router-dom";
import { Settings as SettingsIcon } from "lucide-react";
import SettingsSidebar from "./SettingsSidebar";
import { PageHeader, Chip } from "../../components/em/ui";
import { T } from "../../components/em/tokens";
import "./em-settings.css";

const roleLabel = (role) => {
  const r = (role || "").toLowerCase();
  if (r === "admin") return "Admin";
  if (r === "hr") return "HR";
  return "Employee";
};

const Settings = () => {
  const role = localStorage.getItem("role");

  return (
    <div className="em-settings">
      <PageHeader
        icon={SettingsIcon}
        title="Settings"
        subtitle="Manage your workspace preferences and configuration"
        actions={
          <Chip
            bg={T.orangeSoft}
            color={T.orange}
            border={`1px solid ${T.orangeEdge}`}
          >
            {roleLabel(role)}
          </Chip>
        }
      />

      <div className="em-settings-grid">
        <SettingsSidebar role={role} />
        <main className="em-settings-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Settings;
